import Styled from './NoResults.styled';
import { Button, Typography, TYPOGRAPHY_VARIANT, VisualIcons } from '@tajawal/ct-web-design-system';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Observable } from '@/utils/observer/observer';

function NoResults() {
  const { t } = useTranslation();

  function onModifySearch() {
    Observable.getInstance().notify('desktop-date-picker', true);
  }

  return (
    <Styled.NoResultsWrapper>
      <VisualIcons.NoFlights width="96px" />

      <Styled.HintWrapper>
        <Typography variant={TYPOGRAPHY_VARIANT.HEADING2} component="h2">
          {t('SearchModifier.Title')}
        </Typography>
        <Typography variant={TYPOGRAPHY_VARIANT.BODY1} component="p">
          {t('SearchModifier.SubTitle')}
        </Typography>
      </Styled.HintWrapper>

      <Button onClick={onModifySearch} appearance="secondary">
        {t('SearchResults.Modify_Search') as string}
      </Button>
    </Styled.NoResultsWrapper>
  );
}

export default NoResults;
